module.exports = __webpack_public_path__ + "app/bento-components/video-list/media/play.svg?4a9e8e9906284e8f5eaa61b8c0c074b2";